// @flow

import * as React from 'react';

import ConditionalRoute, {
  ConditionalRouteProps,
} from 'components/RouterProvider/ConditionalRoute';
import { connectDeepTrueAdmin } from 'components/RouterProvider/AuthorizationRoutes/connect';
import consts from 'consts/routing';

const { DASHBOARD } = consts;

const AdminProtectedRoute = ({
  isDeepTrueAdmin,
  ...props
}: ConditionalRouteProps & { isDeepTrueAdmin: boolean }) => (
  <ConditionalRoute isConditionSatisfied={isDeepTrueAdmin} {...props} />
);

AdminProtectedRoute.defaultProps = {
  config: { redirectTo: DASHBOARD },
};

export default connectDeepTrueAdmin(AdminProtectedRoute);
